/* Come si disegna un lavoro di massa nell'header: parte pura, senza React ne' rete, cosi'
   si prova da sola. Il componente (BulkProgress) legge da qui lo stato dell'anello e le
   parole della riga della tendina; il registro degli strumenti gli passa solo colore ed
   etichetta. */

/** Colore di un lavoro fermo o in errore: rosso, qualunque sia lo strumento. */
export const COLORE_ERRORE = '#ef4444';

const fmt = (v) => (v || 0).toLocaleString('it-IT');

/**
 * Stato visivo dell'anello a partire dal lavoro salvato nell'archivio.
 * `job.status` nell'archivio e' 'running' | 'standby' | 'done' | 'error'. Lo 'standby'
 * del server (Google chiede il captcha, il portale non risponde) resta un lavoro IN
 * CORSO a tutti gli effetti (non e' `chiudibile`, non conta come finito): cambia solo
 * `attesa`, che dice al disegno di mostrare la pista tratteggiata che respira, col
 * progresso comunque leggibile. `ignoto` e' un lavoro chiuso senza esito leggibile.
 *
 * @returns {{ tipo: 'corso'|'fine'|'errore'|'ignoto', attesa: boolean, perc: number,
 *             colore: string, chiudibile: boolean }}
 */
export function statoAnello(job, colore) {
  const j = job || {};
  const attesa = j.status === 'standby';
  const inCorso = j.status === 'running' || attesa || !j.status;
  const errore = !inCorso && j.status === 'error';
  const tipo = inCorso ? 'corso' : errore ? 'errore' : j.ignoto ? 'ignoto' : 'fine';
  // Finito: arco pieno. In corso, in attesa o interrotto: l'arco si ferma dove e' arrivato il lavoro.
  const avanzamento = j.total > 0
    ? Math.max(0, Math.min(100, Math.round(((j.completed || 0) / j.total) * 100))) : 0;
  const perc = tipo === 'corso' || tipo === 'errore' ? avanzamento : 100;
  return {
    tipo,
    // in attesa solo quando il lavoro e' ancora in corso: uno chiuso non "attesa" mai
    attesa: tipo === 'corso' && attesa,
    perc,
    colore: tipo === 'errore' ? COLORE_ERRORE : colore,
    // la X c'e' solo quando non c'e' piu' niente che lavora
    chiudibile: tipo !== 'corso',
  };
}

/**
 * Le parole della riga nella tendina: un `esito` in evidenza (può mancare) e il dettaglio.
 * Anche interrotto il lavoro tiene il RIASSUNTO: e' li' che sta il motivo
 * («fermato a mano», «fermo: Google chiede il captcha»).
 */
export function testoLavoro(job) {
  const j = job || {};
  const { tipo } = statoAnello(j, '');
  const riassunto = j.riassunto || '';
  if (tipo === 'corso') {
    return { esito: null, dettaglio: [`${fmt(j.completed)} di ${fmt(j.total)}`, riassunto].filter(Boolean).join(' · ') };
  }
  if (tipo === 'errore') {
    return { esito: `Interrotta a ${fmt(j.completed)} di ${fmt(j.total)}`, dettaglio: riassunto };
  }
  if (tipo === 'ignoto') return { esito: null, dettaglio: 'Esito non disponibile' };
  return { esito: 'Completata', dettaglio: riassunto || fmt(j.completed || j.total) };
}

/** Le chiavi dei lavori che «Chiudi i finiti» toglie: tutti tranne quelli ancora in corso. */
export function chiaviFinite(jobs) {
  return Object.keys(jobs || {}).filter((k) => statoAnello(jobs[k], '').chiudibile);
}
